/**
 * GuestBanner styles
 */

import { StyleSheet } from 'react-native';
import { theme } from '../../../../theme';

export const guestBannerStyles = StyleSheet.create({
  container: {
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: theme.primary,
    paddingHorizontal: 16,
    paddingVertical: 10,
    gap: 12,
  },
  text: {
    flex: 1,
    color: theme.white,
    fontSize: 13,
    fontWeight: '500',
  },
  signUpButton: {
    backgroundColor: theme.white,
    borderRadius: 8,
    paddingHorizontal: 14,
    paddingVertical: 6,
  },
  signUpButtonText: {
    color: theme.primary,
    fontSize: 13,
    fontWeight: '700',
  },
  dismissButton: {
    padding: 4,
  },
  signUpButtonPressed: {
    opacity: 0.85,
  },
  dismissButtonPressed: {
    opacity: 0.7,
  },
});
